module.exports = __webpack_public_path__ + "ea3a44faf90d5bbbb8f7262cfdcda7e3.svg";